import React from 'react';
import './Bar.css';

type Props = {
  labels: (string | number)[];
  progress: number;
  labelColor: string;
  barColor: string;
  separatorColor: string;
};

const Bar = ({
  labels,
  progress,
  labelColor,
  barColor,
  separatorColor,
}: Props) => {
  const style = {
    width: `${progress}%`,
    backgroundColor: barColor,
  };

  return (
    <div className="progress-bar">
      <div className="progress-bar__label-holder">
        <BarLabels labels={labels} color={labelColor} />
      </div>
      <div className="progress-bar__progress-bg">
        <div className="progress-bar__progress" style={style} />
        <BarSegments labels={labels} color={separatorColor} />
      </div>
    </div>
  );
};

type LabelsProps = {
  labels: (string | number)[];
  color: string;
};
const BarLabels = ({ labels, color }: LabelsProps) => {
  const dist = 100 / (labels.length - 1);
  const style = { color };
  return (
    <>
      {labels.map((label, i) => (
        <span
          style={{ left: `${dist * i}%`, ...style }}
          className="label"
          key={label}
        >
          {label}
        </span>
      ))}
    </>
  );
};

type SegmentsProps = {
  labels: (string | number)[];
  color: string;
};
const BarSegments = ({ labels, color }: SegmentsProps) => {
  const dist = 100 / (labels.length - 1);
  return (
    <>
      {labels.map((label, i) =>
        i === 0 || i === labels.length - 1 ? null : (
          <div
            style={{
              left: `${dist * i}%`,
              backgroundColor: color,
            }}
            className="label progress-bar__seperator"
            key={label}
          />
        )
      )}
    </>
  );
};

export default Bar;
